















import {Component, Prop, Vue} from "vue-property-decorator";
import {localStorageService} from "@/services/local-storage.service";
import {IFilm} from "@/interfaces/film.interface";
import {RouterStore} from "@/interfaces/store-interfaces/router-store.interface";

@Component({})
export default class PlayerHead extends Vue {
  baseUrl = process.env.VUE_APP_PUBLIC_URL;
  routePath = RouterStore.ROUTE_PATH;

  @Prop() item: IFilm;

  @Prop() id?: string;
  @Prop() title: string;
  @Prop() subtitle: string;
  @Prop() arrow: boolean;
  @Prop() like: boolean;
  @Prop() rhizome: boolean;
  @Prop() videoSwitcher?: boolean;
  @Prop({ default: false }) hideActions?: boolean;

  @Prop() onClick?: Function;
  @Prop() payload?: number;

  isFavoriteFilm: boolean = false;

  mounted() {
    this.isFavoriteFilm = localStorageService.getFavoriteList().includes(Number(this.id));
  }

  toggleLike() {
    localStorageService.toggleFavoriteFilm(Number(this.id));
    this.isFavoriteFilm = !this.isFavoriteFilm;
  }

  async openFilmPage() {
    if (this.hideActions) return;
    if (this.videoSwitcher) {
      this.onClick(this.payload);
    }
    else {
      await this.$store.dispatch('routerStore/openFilmPage', Number(this.id));
    }
  }

  async openFilmOnRhizome() {
    await this.$store.dispatch('rhizome/openFilmOnRhizome', { filmId: Number(this.id) });
  }
}
